<app-sign-up-container [largeContainer]="true">
    <h1 class="text-center mb-0">{{ 'Get started with PayHOA' }}</h1>
    <h2 class="text-center">{{ 'Select the option that best describes you:' }}</h2>
    <div class="grid-layout grid-3">
        <div class="card animated fadeIn clickable"
             [attr.tabindex]="0"
             [routerLink]="['/sign-up/' + signupFormTypes.HOMEOWNER]">
            <div class="card-body text-center">
                <img alt="{{ signupFormTypes.HOMEOWNER }}" src="/assets/images/signup/signup-homeowner.svg"/>
                <h3>{{ 'Homeowner' }}</h3>
                <span class="description-text">{{ 'Access my homeowner portal.' }}</span>
            </div>
        </div>

        <div class="card animated animated-delay fadeIn clickable"
             [attr.tabindex]="0"
             [routerLink]="['/sign-up/' + signupFormTypes.BOARD_MEMBER]">
            <div class="card-body text-center">
                <img alt="{{ signupFormTypes.BOARD_MEMBER }}" src="/assets/images/signup/signup-boardmember.svg"/>
                <h3>{{ 'HOA Board Member' }}</h3>
                <span class="description-text">{{ 'Create a PayHOA account to manage my community.' }}</span>
            </div>
        </div>

        <div class="card animated animated-delay fadeIn clickable"
             [attr.tabindex]="0"
             [routerLink]="['/sign-up/' + signupFormTypes.PROPERTY_MANAGER]">
            <div class="card-body text-center">
                <img alt="{{ signupFormTypes.PROPERTY_MANAGER }}" src="/assets/images/signup/signup-propertymgr.svg"/>
                <h3>{{ 'Property Manager' }}</h3>
                <span class="description-text">{{ 'Create a PayHOA account to manage multiple communities.' }}</span>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-center pt-3 font-size-normal">
        <span class="mr-1">{{ 'Already have an account?' }}</span>
        <app-button type="link"
                    [buttonClasses]="['mr-0']"
                    [routeTo]="['/auth/login']">
            {{ 'Log in' }}
        </app-button>
    </div>
</app-sign-up-container>
